import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { differenceWith, intersectionWith, isEqual } from 'lodash';

import { CellMeasurer, CellMeasurerCache } from 'react-virtualized/dist/commonjs/CellMeasurer';
import { List } from 'react-virtualized/dist/commonjs/List';
import { Filter } from './filter_components';
import { Desktop, Mobile } from '../../components/MediaQuery';
import { Brand } from '../../common/models/FilterSettings';
import FilterClearButton from './styled_components/FilterClearButton';

interface BrandsFilterProps {
  availableBrands: Brand[];
  handleFilterClick: (brandsIds: string[]) => void;
  isDesktop: boolean;
  selectedBrandsIds: string[];
}

interface BrandsFilterState {
  listWidth: number;
}

class BrandsFilter extends Component<BrandsFilterProps, BrandsFilterState> {
  constructor(props: BrandsFilterProps) {
    super(props);
    this.state = { listWidth: 300 };
    this.cellMeasurerCache = new CellMeasurerCache({
      fixedWidth: true,
      defaultHeight: 50
    });
    this.list = null;

    this.updateSelection = this.updateSelection.bind(this);
  }

  componentDidMount = () => {
    if (this.list) {
      const listNode = ReactDOM.findDOMNode(this.list);
      this.cellMeasurerCache.clearAll();
      this.list.forceUpdateGrid();
      this.setState({ listWidth: listNode.parentElement.getBoundingClientRect().width });
    }
  };

  cellMeasurerCache: any;

  list: any;

  updateSelection(selectedBrand: Brand) {
    let alreadySelectedBrandsIds = this.props.selectedBrandsIds;

    const selected = intersectionWith<string, string>(alreadySelectedBrandsIds, [selectedBrand.id], isEqual);
    if (selected.length !== 0) {
      alreadySelectedBrandsIds = differenceWith<string, string>(alreadySelectedBrandsIds, [selectedBrand.id], isEqual);
    } else {
      alreadySelectedBrandsIds = alreadySelectedBrandsIds.concat(selectedBrand.id);
    }

    this.props.handleFilterClick(alreadySelectedBrandsIds.map(e => e.toString()));
  }

  rowRenderer = ({ index, key, style, parent }) => {
    const { selectedBrandsIds, isDesktop, availableBrands } = this.props;
    const brand = availableBrands[index];

    const isSelected = selectedBrandsIds.includes(brand.id);

    return (
      <CellMeasurer key={key} cache={this.cellMeasurerCache} columnIndex={0} parent={parent} rowIndex={index}>
        <div key={key} style={style}>
          <Filter
            key={key}
            active
            checked={isSelected}
            handleFilterClick={() => {
              this.updateSelection(brand);
            }}
            id={brand.id}
            isDesktop={isDesktop}
            noTopPadding={false}
            style={null}
            title={brand.name}
          />
        </div>
      </CellMeasurer>
    );
  };

  render() {
    const { availableBrands, isDesktop, handleFilterClick, selectedBrandsIds } = this.props;
    const { listWidth } = this.state;

    if (this.list) {
      this.cellMeasurerCache.clearAll();
      this.list.forceUpdateGrid();
    }

    const listProps = {
      width: listWidth,
      rowCount: availableBrands.length,
      deferredMeasurementCache: this.cellMeasurerCache,
      rowHeight: this.cellMeasurerCache.rowHeight,
      rowRenderer: this.rowRenderer,
      ref: element => {
        this.list = element;
      },
      className: 'brand-list'
    };

    const atLeastOneSelected = selectedBrandsIds.length > 0;

    return (
      <div>
        {atLeastOneSelected && <FilterClearButton handleClick={() => handleFilterClick([])} isDesktop={isDesktop} />}
        <Mobile>
          <List height={availableBrands.length < 5 ? 36 * availableBrands.length : 200} {...listProps} />
        </Mobile>
        <Desktop>
          <List height={availableBrands.length < 15 ? 25 * availableBrands.length : 300} {...listProps} />
        </Desktop>
      </div>
    );
  }
}

export default BrandsFilter;
